// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check localStorage when app loads
    // const storedUserType = localStorage.getItem('userType');
    // const storedUserId = localStorage.getItem('userId');

    const storedUserType = sessionStorage.getItem('userType');
const storedUserId = sessionStorage.getItem('userId');

    
    if (storedUserType && storedUserId) {
      setIsAuthenticated(true);
      setUserType(storedUserType);
      setUserId(storedUserId);
    }
    
    setLoading(false);
  }, []);

  const login = (userId, userType) => {
    // localStorage.setItem('userId', userId);
    // localStorage.setItem('userType', userType);
    sessionStorage.setItem('userId', userId);
sessionStorage.setItem('userType', userType);
sessionStorage.setItem('isLoggedIn', 'true');
    setIsAuthenticated(true);
    setUserType(userType);
    setUserId(userId);
  };

  const logout = () => {
    // localStorage.removeItem('userId');
    // localStorage.removeItem('userType');
    sessionStorage.removeItem('userId');
sessionStorage.removeItem('userType');
sessionStorage.removeItem('isLoggedIn', 'false');

    setIsAuthenticated(false);
    setUserType(null);
    setUserId(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, userType, userId, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}